var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isAuthenticated ? _c('div', {
    staticClass: "d-flex flex-column flex-root"
  }, [_c('div', {
    staticClass: "d-flex flex-row flex-column-fluid page"
  }, [_c('div', {
    staticClass: "content d-flex flex-column flex-column-fluid",
    attrs: {
      "id": "kt_content"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column-fluid"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.isLoading ? _c('Loading') : _vm._e()], 1), _c('div', {
    staticClass: "d-lg-flex flex-row-fluid"
  }, [_vm.asideEnabled ? _c('KTAside') : _vm._e(), _c('div', {
    staticClass: "content-wrapper flex-row-fluid"
  }, [_c('transition', {
    attrs: {
      "name": "fade-in-up"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };